import script from "./UserProfileContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileContent.vue?vue&type=script&setup=true&lang=ts"

import "./UserProfileContent.vue?vue&type=style&index=0&id=432c79c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432c79c6"]])

export default __exports__